<template>
    <v-form v-model="formValido" ref="formInterno">
            <v-card>
                <v-card-title>
                    Emitente
                </v-card-title>
                <v-card-text>
                    <div>
                        <v-row>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.cpfOrCnpjEmitente" v-mask="'##.###.###/####-##'"
                                    clearable outlined label="CNPJ/CPF" @blur="getCnpjInfo(objNf.cpfOrCnpjEmitente, 'Emitente')"
                                    :rules="[v => !!v || 'Emitente é obrigatório']" 
                                />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                            <v-text-field v-model="objNf.razaoSocialNomeEmitente" clearable outlined
                                label="Razão Social/Nome" :rules="[v => !!v || 'Razão Social é obrigatório']" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <!-- <v-text-field v-model="objNf.cnae" readonly clearable outlined label="CNAE da Empresa"
                                    :rules="[v => !!v || 'CNAE é obrigatório']" /> -->

                                <v-autocomplete 
                                    :rules="[v => !!v || 'CNAE é obrigatório']"
                                    v-model="objNf.cnae"
                                    :items="cnaeList"
                                    item-text="codigo"
                                    item-value="id" 
                                    label="CNAE" 
                                    dense 
                                    outlined
                                >
                                    <template v-slot:item="{ item }">
                                        <div class="d-flex flex-column">
                                            <div class="font-weight-bold">{{ item.codigo }}</div>
                                            <div>{{ item.descricao }}</div>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.inscricaoMinucipal" clearable outlined
                                    label="Inscrição Municipal" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.localEmissao" clearable outlined label="Local de Emissão" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.emitenteLogradouro" clearable outlined label="Logradouro" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.emitenteBairro" clearable outlined label="Bairro" />
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-text-field v-model="objNf.emitenteCodCidade" clearable outlined label="Código da Cidade" />
                            </v-col>
                        </v-row>
                    </div>

                    <div>
                        <v-row>
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete 
                                    v-model="objNf.regimeTributario"
                                    :items="regimeTributarioList" 
                                    item-text="descricao"
                                    item-value="id" 
                                    label="Regime Tributario" 
                                    dense 
                                    outlined
                                >
                                    <template v-slot:item="{ item }">
                                        <div class="d-flex flex-column">
                                            <div class="font-weight-bold">{{ item.codigo }}</div>
                                            <div>{{ item.descricao }}</div>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete 
                                    v-model="objNf.enquadramento"
                                    :items="enquadramentoList" 
                                    item-text="descricao"
                                    item-value="id" 
                                    label="Enquadramento" 
                                    dense 
                                    outlined
                                >
                                    <template v-slot:item="{ item }">
                                        <div class="d-flex flex-column">
                                            <div class="font-weight-bold">{{ item.codigo }}</div>
                                            <div>{{ item.descricao }}</div>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-autocomplete 
                                    v-model="objNf.tributacaoMunicipal"
                                    :items="tributacaoList" 
                                    item-text="naturezaOperacao"
                                    item-value="id" 
                                    label="Tributação Municipal" 
                                    dense 
                                    outlined
                                    return-object
                                    @change="selectedTributacao"
                                >
                                    <template v-slot:item="{ item }">
                                        <div class="d-flex flex-column">
                                            <div class="font-weight-bold">{{ item.codigo }}</div>
                                            <div>{{ item.naturezaOperacao }}</div>
                                        </div>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-combobox 
                                    v-model="objNf.enqServico" 
                                    :items="['MEI', 'Simples Nacional', 'Lucro Presumido']"
                                    clearable outlined label="Tipo de Enquadramento" 
                                />
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>

            <v-card class="mb-5 mt-5">
                <v-card-title>
                    Tomador do Serviço
                </v-card-title>

                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="3">
                            <v-autocomplete 
                                clearable outlined label="Cliente" 
                                v-model="objNf.destinatario" 
                                :items="clientes" 
                                item-value="id"
                                item-text="nomeFantasia"
                                return-object
                                @change="onSelectedClienteChange"
                            />
                        </v-col>

                        <v-col cols="3">
                            <v-text-field v-model="objNf.cpfOrCnpjTomador" v-mask="'##.###.###/####-##'" clearable
                                outlined label="CNPJ/CPF" @blur="getCnpjInfo(objNf.cpfOrCnpjTomador, 'Tomador')"
                                :rules="[v => !!v || 'CNPJ é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.razaoSocialNomeTomador" clearable outlined
                                label="Razão Social/Nome" :rules="[v => !!v || 'Razão Social é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.inscricaoMinucipalTomador" clearable outlined
                                label="Inscrição Municipal"
                                 />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field readonly v-model="objNf.endereco" clearable outlined label="Endereço Completo"
                                :rules="[v => !!v || 'Endereço é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.codigoCidade" clearable outlined label="Código da Cidade"
                                :rules="[v => !!v || 'Código é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorUf" clearable outlined label="UF"
                                :rules="[v => !!v || 'UF é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorNumero" clearable outlined label="Número" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorComplemento" clearable outlined label="Complemento" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorCep" clearable outlined label="CEP"
                                :rules="[v => !!v || 'CEP é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.tomadorEmail" clearable outlined label="E-mail"
                                :rules="[v => !!v || 'E-mail é obrigatório']" />
                        </v-col>
                        <v-col cols="3">
                            <v-text-field v-model="objNf.localRecebimento" clearable outlined
                                label="Local do Recebimento" />
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>

            <v-card>
                <v-card-title>
                    Job
                </v-card-title>

                <v-card-text>
                    <v-autocomplete 
                        v-model="objNf.job" 
                        :items="projects" 
                        item-text="code" 
                        item-value="id"
                        label="JOB" 
                        dense 
                        outlined
                        @change="selectedJob"
                        return-object
                    >
                    </v-autocomplete>

                    <v-data-table
                        v-model="objNf.jobItens"
                        :headers="headers"
                        :items="dataItensJob"
                        class="elevation-1"
                        disable-sort
                        hide-default-footer
                        show-select 
                        color="primary"
                        return-object
                    >
                        <template v-slot:item.precoUnitario="{ item }">
                            <span>{{ formatCurrencyFromNumber(item.precoUnitario) }}</span>
                        </template>

                        <template v-slot:item.precoTotal="{ item }">
                            <span>{{ formatCurrencyFromNumber(item.precoTotal) }}</span>
                        </template>
                    </v-data-table>

                    <v-row class="mt-5">
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined 
                                label="Valor da Nota"
                                v-model="objNf.valorNf" 
                                :readonly="true"
                                :key="updtaeSum"
                            />
                        </v-col>
                        
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined 
                                label="Base Calculo"
                                v-model="objNf.baseCalculo" 
                                :key="updtaeSum"
                            />
                        </v-col>

                        <v-col cols="12" sm="6" md="2">
                            <v-combobox 
                                :items="aliquoataOptions" 
                                clearable 
                                outlined
                                label="Aliquota(%)"
                                v-model="objNf.aliquota"
                            />
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined
                                label="Imposto"
                                v-model="objNf.imposto"
                            />
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                            <v-text-field 
                                v-money="money" 
                                clearable outlined
                                label="Dedutivel"
                                v-model="objNf.dedutivel"
                            />
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>

        <div class="mb-5 mt-5" style="width: 100%">
            <v-card>
                <v-card-title>
                    Parcelas - {{ sumParcelas()?.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' }) }} - {{ formatCurrencyFromCents(valorNf) }}
                </v-card-title>

                <div>
                <v-row dense v-for="parcela in parcelas" :key="parcela.numParcela">
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="N° Parcela" v-model="parcela.numParcela" readonly />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="Data de Vencimento" type="date" v-model="parcela.vencimento" />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            :rules="[
                                v => {
                                    const valor = valorNf
                                    return valor >= sumParcelas() || 'Não pode ultrapassar a parcela'
                                }
                            ]"
                            clearable outlined label="Valor da Parcela" 
                            v-money="money" 
                            v-model="parcela.vrlParcela" 
                        />
                    </v-col>

                    <!-- Botão com ícone ao final -->
                    <v-col cols="12" sm="6" md="4" >
                        <v-btn color="primary" icon @click="addParcela()">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn color="error" icon @click="removeParcela(parcela)">
                            <v-icon>mdi-minus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                </div>

            </v-card>
        </div>
            

            <v-card>
                <v-card-title>
                    Serviço Prestado
                </v-card-title>

                <v-card-title :key="componentKey">
                    <v-row dense>
                        <v-col cols="12" md="12" lg="12">
                            <v-text-field v-model="objNf.tipoServico" clearable outlined label="Tipo de Serviço" />
                        </v-col>

                        <!-- <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.codMunicipio" clearable outlined label="Código do serviço no município" />
                        </v-col> -->

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.pis" v-money="money" clearable outlined label="PIS" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.confins" v-money="money" clearable outlined label="COFINS" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.csll" v-money="money" clearable outlined label="CSLL" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.ir" v-money="money" clearable outlined label="IR" @blur="calcImpostos()" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                        <v-text-field v-model="objNf.inss" v-money="money" clearable outlined label="ISS" @blur="calcImpostos" />
                        </v-col>

                        <!-- <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.iss" v-money="money" clearable outlined label="ISS" @blur="calcImpostos" />
                        </v-col> -->

                        <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.liquidos" :key="updtaeSum" v-money="money" clearable outlined label="Valor Líquido" :readonly="true" />
                        </v-col>
<!--
                        <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.dataEmit" type="date" clearable outlined label="Data de Emissão" :readonly="true" />
                        </v-col>

                        <v-col cols="12" md="6" lg="3">
                            <v-text-field v-model="objNf.dateVenc" type="date" clearable outlined label="Data de Vencimento" />
                        </v-col> --->
                        <v-col cols="12" md="12" lg="12">
                            <v-textarea v-model="objNf.descricao" clearable outlined label="Descrição detalhada do serviço prestado" />
                        </v-col>
                    </v-row>
                </v-card-title>

            </v-card>

            <v-card class="mb-5 mt-5">
                <v-card-title>
                    IBS/CBS
                </v-card-title>

                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="4">
                            <v-switch
                                v-model="objNf.informarIbsCbs"
                                inset
                                label="Informar NBS / IBSCBS"
                            />
                        </v-col>
                    </v-row>

                    <template v-if="objNf.informarIbsCbs">
                        <v-row dense>
                            <v-col cols="12" sm="6" md="6">
                                <v-autocomplete
                                    v-model="objNf.cstIbsCbs"
                                    :items="notaFiscalItemCST"
                                    item-text="descricao"
                                    item-value="id"
                                    label="CST"
                                    dense
                                    outlined
                                >
                                    <template v-slot:item="{ item }">
                                        <div>{{ item.codigo }} - {{ item.descricao }}</div>
                                    </template>
                                    <template v-slot:selection="{ item }">
                                        <span>{{ item.codigo }} - {{ item.descricao }}</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-autocomplete
                                    v-model="objNf.classificacaoIbsCbs"
                                    :items="notaFiscalItemClassificacao"
                                    item-text="descricao"
                                    item-value="id"
                                    label="Classificação Tributária"
                                    dense
                                    outlined
                                >
                                    <template v-slot:item="{ item }">
                                        <div>{{ item.codigo }} - {{ item.descricao }}</div>
                                    </template>
                                    <template v-slot:selection="{ item }">
                                        <span>{{ item.codigo }} - {{ item.descricao }}</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-autocomplete
                                    v-model="objNf.nbs"
                                    :items="nbsList"
                                    item-text="descricao"
                                    item-value="id"
                                    label="NBS"
                                    dense
                                    outlined
                                >
                                    <template v-slot:item="{ item }">
                                        <div>{{ item.codigo }} - {{ item.descricao }}</div>
                                    </template>
                                    <template v-slot:selection="{ item }">
                                        <span>{{ item.codigo }} - {{ item.descricao }}</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                                <v-combobox
                                    v-model="objNf.indicadorOperacao"
                                    :items="indicadorOperacaoOptions"
                                    clearable
                                    dense
                                    outlined
                                    label="Indicador de Operação"
                                />
                            </v-col>

                            <v-col cols="12" sm="6" md="3">
                                <v-text-field
                                    v-model="objNf.valorBaseCalculoIbsCbs"
                                    v-money="money"
                                    outlined
                                    readonly
                                    label="Valor da Base de Cálculo"
                                />
                            </v-col>
                        </v-row>

                        <v-simple-table class="mt-4">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Tributo</th>
                                        <th class="text-left">Alíquota</th>
                                        <th class="text-left">Redução</th>
                                        <th class="text-left">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>CBS</td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.aliquotaCbs"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.reducaoCbs"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>{{ formatCurrencyFromCents(objNf.valorCbs) }}</td>
                                    </tr>
                                    <tr>
                                        <td>IBS Estadual</td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.aliquotaIbsEstadual"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.reducaoIbsEstadual"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>{{ formatCurrencyFromCents(objNf.valorIbsEstadual) }}</td>
                                    </tr>
                                    <tr>
                                        <td>IBS Municipal</td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.aliquotaIbsMunicipal"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>
                                            <v-text-field
                                                v-model="objNf.reducaoIbsMunicipal"
                                                dense
                                                hide-details
                                                outlined
                                            />
                                        </td>
                                        <td>{{ formatCurrencyFromCents(objNf.valorIbsMunicipal) }}</td>
                                    </tr>
                                    <tr>
                                        <td>Total</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>{{ formatCurrencyFromCents(objNf.totalIbsCbs) }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </template>
                </v-card-text>
            </v-card>

    </v-form>
</template>

<script>
import {VMoney} from 'v-money'
import Vue from 'vue';
export default {
    name: 'NotaFiscalServico',
    directives: { money: VMoney },
    props: ['projects', 'userInfo', 'item', 'isOpen', 'valorNf', 'clientes', 'clienteSelected', 'pacelasCads'],
    data(){
        return {
            openExpansionJobOs: false,
            salesOrders: [],
            syncingFromParent: false,
            isCalculatingImpostos: false,
            componentKey: 0,
            totalNf: 0,
            formValido: false,
            updtaeSum: 0,
            lastSelectedClienteId: null,
            money: {
                locale: "pt-br",
                decimal: '.',
                thousands: '.',
                prefix: '',
                precision: 2,
                masked: false
            },
            parcelas: this.pacelasCads.length > 0 ?  this.pacelasCads : [
                { numParcela: '01', vencimento: null, vrlParcela: 0 }
            ],
            aliquoataOptions: [
                { text: '2%', value: 2 },
                { text: '3%', value: 3 },
                { text: '4%', value: 4 },
                { text: '5%', value: 5 }
            ],
            headers: [
                { text: 'Descrição', value: 'descricao' },
                { text: 'Tipo', value: 'tipo' },
                { text: 'Quantidade', value: 'quantidade' },
                { text: 'Preço Unitario', value: 'precoUnitario' },
                { text: 'Preço Total', value: 'precoTotal' }
            ],
            dataItensJob: [],
            regimeTributarioList: [],
            enquadramentoList: [],
            nbsList: [],
            tributacaoList: [],
            cnaeList: [],
            notaFiscalItemCST: [],
            notaFiscalItemClassificacao: [],
            indicadorOperacaoOptions: ['100301'],
            objNf: {
                baseCalculo: null,
                id: null,
                cpfOrCnpjEmitente: null,
                razaoSocialNomeEmitente: null,
                cpfOrCnpjTomador: null,
                razaoSocialNomeTomador: null,
                cnae: null,
                inscricaoMinucipal: '',
                inscricaoMinucipalTomador: '',
                endereco: null,
                codigoCidade: '',
                localEmissao: null,
                emitenteLogradouro: null,
                emitenteBairro: null,
                emitenteCodCidade: null,
                localRecebimento: null,
                tipoServico: '',
                descricao: '',
                enqServico: '',
                codMunicipio: '',
                job: null,
                os: null,
                dataEmit: null,
                dateVenc: null,
                valorNota: null,
                pis: 0,
                confins: 0,
                csll: 0,
                ir: 0,
                inss: 0,
                aliIss: 0,
                valueIss: 0,
                tributos: null,
                liquidos: 0,
                tomadorUf: null,
                tomadorNumero: null,
                tomadorCep: null,
                tomadorEmail: null,
                jobItens: [],
                regimeTributario: null,
                tributacaoMunicipal: null,
                aliquota: null,
                imposto: null,
                dedutivel: null,
                informarIbsCbs: true,
                cstIbsCbs: undefined,
                classificacaoIbsCbs: undefined,
                nbs: undefined,
                indicadorOperacao: '100301',
                valorBaseCalculoIbsCbs: 0,
                aliquotaCbs: 0.9,
                aliquotaIbsEstadual: 0.1,
                aliquotaIbsMunicipal: 0,
                reducaoCbs: 0,
                reducaoIbsEstadual: 0,
                reducaoIbsMunicipal: 0,
                valorCbs: 0,
                valorIbsEstadual: 0,
                valorIbsMunicipal: 0,
                totalIbsCbs: 0
            }
        }
    },
    methods: {
        resolveEntityId(value) {
            if (value == null) return null

            if (typeof value === 'object') {
                return value?.id || value?._id || null
            }

            const normalized = String(value).trim()
            if (!normalized || normalized === '[object Object]') return null

            return normalized
        },

        async getDataEntity(schemaName){
            const response = await Vue.prototype.$http.get(`/Entity/${schemaName}`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            });

            return response.data.data.data
        },

        async getNotaFiscalItemCST() {
            const response = await Vue.prototype.$http.get('/Entity/NotaFiscalItemCST', {
                params: {
                    page: 1,
                    limit: 9999
                }
            });

            this.notaFiscalItemCST = response.data.data.data;
        },

        async getNotaFiscalItemClassificacao() {
            const response = await Vue.prototype.$http.get('/Entity/NotaFiscalItemClassificacaoTributaria', {
                params: {
                    page: 1,
                    limit: 9999
                }
            });

            this.notaFiscalItemClassificacao = response.data.data.data;
        },

        toIntegerMoney(value) {
            if (value == null || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? Math.round(value) : 0;
            return Number(String(value).replace(/\D/g, '')) || 0;
        },

        toDecimalNumber(value) {
            if (value == null || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

            const rawValue = String(value).trim().replace(/\s/g, '');
            if (!rawValue) return 0;

            const sanitizedValue = rawValue.replace(/[^\d,.-]/g, '');
            const lastCommaIndex = sanitizedValue.lastIndexOf(',');
            const lastDotIndex = sanitizedValue.lastIndexOf('.');

            let normalizedValue = sanitizedValue;

            if (lastCommaIndex > -1 && lastDotIndex > -1) {
                if (lastCommaIndex > lastDotIndex) {
                    normalizedValue = sanitizedValue.replace(/\./g, '').replace(',', '.');
                } else {
                    normalizedValue = sanitizedValue.replace(/,/g, '');
                }
            } else if (lastCommaIndex > -1) {
                normalizedValue = sanitizedValue.replace(/\./g, '').replace(',', '.');
            } else {
                const dotMatches = sanitizedValue.match(/\./g) || [];
                if (dotMatches.length > 1) {
                    const integerPart = sanitizedValue.slice(0, lastDotIndex).replace(/\./g, '');
                    const decimalPart = sanitizedValue.slice(lastDotIndex + 1);
                    normalizedValue = `${integerPart}.${decimalPart}`;
                }
            }

            const numericValue = Number(normalizedValue);
            return Number.isFinite(numericValue) ? numericValue : 0;
        },

        parseAliquotaDecimal(value) {
            const numericValue = this.toDecimalNumber(value);
            if (numericValue === 0) return 0;
            return numericValue > 1 ? numericValue / 100 : numericValue;
        },

        formatCurrencyFromCents(value) {
            return Number((this.toIntegerMoney(value) || 0) / 100).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        },

        formatCurrencyFromNumber(value) {
            const numericValue = Number(value || 0);
            return Number.isFinite(numericValue)
                ? numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                : Number(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },

        formatPercentualIbsCbs(value) {
            return `${Number(value || 0).toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}%`;
        },

        parsePercentualIbsCbs(value) {
            if (value == null || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

            const normalized = String(value)
                .trim()
                .replace(/\./g, '')
                .replace(',', '.');

            return Number(normalized) || 0;
        },

        limparIbsCbsServico() {
            this.objNf.valorBaseCalculoIbsCbs = 0;
            this.objNf.valorCbs = 0;
            this.objNf.valorIbsEstadual = 0;
            this.objNf.valorIbsMunicipal = 0;
            this.objNf.totalIbsCbs = 0;
        },

        calcularIbsCbsServico() {
            if (!this.objNf.informarIbsCbs) {
                this.limparIbsCbsServico();
                return;
            }

            const base = this.toIntegerMoney(this.objNf.baseCalculo || this.objNf.valorNf || (Number(this.valorNf) * 100));
            const aliquotaCbs = this.parseAliquotaDecimal(this.objNf.aliquotaCbs) * 100;
            const aliquotaIbsEstadual = this.parseAliquotaDecimal(this.objNf.aliquotaIbsEstadual) * 100;
            const aliquotaIbsMunicipal = this.parseAliquotaDecimal(this.objNf.aliquotaIbsMunicipal) * 100;
            const reducaoCbs = this.parsePercentualIbsCbs(this.objNf.reducaoCbs);
            const reducaoIbsEstadual = this.parsePercentualIbsCbs(this.objNf.reducaoIbsEstadual);
            const reducaoIbsMunicipal = this.parsePercentualIbsCbs(this.objNf.reducaoIbsMunicipal);

            const baseCbs = base * Math.max(0, 1 - (reducaoCbs / 100));
            const baseIbsEstadual = base * Math.max(0, 1 - (reducaoIbsEstadual / 100));
            const baseIbsMunicipal = base * Math.max(0, 1 - (reducaoIbsMunicipal / 100));

            this.objNf.valorBaseCalculoIbsCbs = base;
            this.objNf.valorCbs = Math.round(baseCbs * (aliquotaCbs / 100));
            this.objNf.valorIbsEstadual = Math.round(baseIbsEstadual * (aliquotaIbsEstadual / 100));
            this.objNf.valorIbsMunicipal = Math.round(baseIbsMunicipal * (aliquotaIbsMunicipal / 100));
            this.objNf.totalIbsCbs = this.objNf.valorCbs + this.objNf.valorIbsEstadual + this.objNf.valorIbsMunicipal;
        },

        async selectedJob(job){
            let jobEntity = job
            const jobId = this.resolveEntityId(job)

            if (!jobEntity) {
                this.dataItensJob = []
                return
            }

            if (typeof jobEntity !== 'object') {
                if (!jobId) {
                    this.dataItensJob = []
                    return
                }

                const responseJob = await Vue.prototype.$http.get(`/Entity/Project/${jobId}`)
                jobEntity = responseJob?.data?.data
            }

            if (!Array.isArray(jobEntity?.jobItens) || jobEntity.jobItens.length === 0) {
                this.dataItensJob = []
                return
            }

            const response = await Vue.prototype.$http.get(`/Entity/ProjectItens`, {
                params: {
                    ids: jobEntity.jobItens.map((id) => id).join(',')
                }
            })

            this.dataItensJob = response.data.data.data
        },

        selectedTributacao(tributacao){
            this.objNf.aliquota = tributacao.aliquotaIss * 100
            this.updtaeSum += 1
            this.calcImpostos()
        },

        onSelectedClienteChange(cliente) {
            if (!cliente?.id) return
            if (this.lastSelectedClienteId === cliente.id) return

            this.lastSelectedClienteId = cliente.id
            this.$emit('selectedCliente', cliente)
        },

        async getEmitente(){
            const filial = localStorage.getItem('CompanySiteIdSelected')
            if (!filial) {
                this.$notfy?.warning('Filial não selecionada. Selecione a empresa para continuar.')
                return
            }

            try {
                const response = await Vue.prototype.$http.get(`/Entity/CompanySite/${filial}`);
                this.objNf.cpfOrCnpjEmitente = response?.data?.data?.cnpj || ''
                await this.getCnpjInfo(response?.data?.data?.cnpj, 'Emitente')
            } catch (error) {
                console.error('[NF Serviço] Falha ao carregar dados do emitente:', error)
                this.$notfy?.error('Não foi possível carregar os dados do emitente.')
            }
        },

        async getCnpjInfo(value, tipo){
            if(value?.length == 18){
                let response
                try {
                    response = await Vue.prototype.$http.post('/Action/run', 
                        { 
                            actionId: "128f5633-f624-41f8-abcf-043bc39a4bb7",
                            actionName: "Action info CNPJ",
                            params: { 
                                cnpj: value.replace(/\D/g, '')
                            } 
                        })
                } catch (error) {
                    console.error('[NF Serviço] Falha ao consultar Action info CNPJ:', error)
                    this.$notfy?.error('Não foi possível consultar os dados do CNPJ.')
                    return
                }



                if(response.data.data.data?.status == "ERROR" && tipo == 'Emitente'){
                    this.$notfy.error("CNPJ invalido.");
                    this.objNf.cpfOrCnpjEmitente = ''
                    return
                }

                if(response.data.data.data?.status == "ERROR" && tipo == 'Tomador'){
                    this.$notfy.error("CNPJ invalido.");
                    this.objNf.cpfOrCnpjTomador = ''
                    return
                }

                const info = response?.data?.data?.data
                if (!info || typeof info !== 'object') {
                    this.$notfy?.error('Resposta inválida ao consultar os dados do CNPJ.')
                    return
                }

                if(tipo == 'Emitente'){
                    this.objNf.razaoSocialNomeEmitente = info.fantasia || info.nome
                    //this.objNf.cnae = info.atividade_principal[0].code
                    this.objNf.localEmissao = info.municipio
                    this.objNf.emitenteLogradouro = info.logradouro
                    this.objNf.emitenteBairro = info.bairro
                } 
                else if(tipo == 'Tomador'){
                    this.objNf.razaoSocialNomeTomador = info.fantasia || info.nome
                    this.objNf.endereco = `Cidade: ${info.municipio} - Rua: ${info.logradouro} - Bairro: ${info.bairro}` 
                    this.objNf.localRecebimento = info.logradouro + info.numero
                    this.objNf.tomadorEmail = info.email
                    this.objNf.tomadorNumero = info.numero
                    this.objNf.tomadorUf = info.uf
                    this.objNf.tomadorCep = info.cep
                }

                this.componentKey += 1
            }
        },


        sumParcelas(){
            return (this.sumParcelasInCents() / 100) || 0
        },

        sumParcelasInCents() {
            let sum = 0
            this.parcelas?.forEach((p) => {
                if (p?.vrlParcela == null || p?.vrlParcela === '') return
                sum += this.toIntegerMoney(p.vrlParcela)
            })

            return sum
        },

        addParcela(){
            this.parcelas.push({ 
                numParcela: String(this.parcelas.length + 1).padStart(2, '0'), 
                vencimento: null, 
                vrlParcela: 0 
            })  
        },

        async removeParcela(parcela){
            this.parcelas =  this.parcelas.filter((p) => p.numParcela != parcela.numParcela)

            if(parcela.id){
                //await Vue.prototype.$http.delete(`/Entity/FisPreDocEmiFin?id=${parcela.id}`)
            }

        },


        calcImpostos() {
            if (this.isCalculatingImpostos) return
            this.isCalculatingImpostos = true

            try {
                const base = this.toIntegerMoney(this.objNf.baseCalculo || this.objNf.valorNf || (Number(this.valorNf) * 100))
                const trib = this.objNf.tributacaoMunicipal || {}
                const aliquotaIss = this.parseAliquotaDecimal(this.objNf.aliquota)
                const dedutivel = this.toIntegerMoney(this.objNf.dedutivel)

                if (this.objNf.baseCalculo !== base) {
                    this.objNf.baseCalculo = base
                }
                this.objNf.pis = Math.round(base * this.parseAliquotaDecimal(trib.pis))
                this.objNf.confins = Math.round(base * this.parseAliquotaDecimal(trib.cofins))
                this.objNf.csll = Math.round(base * this.parseAliquotaDecimal(trib.csll))
                this.objNf.inss = Math.round(base * this.parseAliquotaDecimal(trib.inss))
                this.objNf.ir = Math.round(base * this.parseAliquotaDecimal(trib.ir))
                this.objNf.imposto = Math.round(base * aliquotaIss)

                const totalImpostos =
                    this.objNf.pis +
                    this.objNf.confins +
                    this.objNf.csll +
                    this.objNf.inss +
                    this.objNf.ir +
                    this.objNf.imposto

                this.objNf.liquidos = Math.max(base - totalImpostos - dedutivel, 0)
                this.calcularIbsCbsServico()

                this.componentKey += 1
            } finally {
                this.$nextTick(() => {
                    this.isCalculatingImpostos = false
                })
            }
        }




    },
    watch: {

        item: {
            async handler(value){
                // console.log('ITEM HANDLER ', value)
                this.syncingFromParent = true

                this.objNf = {
                    ...this.objNf,
                    ...value,
                    informarIbsCbs: value?.informarIbsCbs ?? true,
                    indicadorOperacao: value?.indicadorOperacao ?? '100301',
                    aliquotaCbs: value?.aliquotaCbs ?? 0.9,
                    aliquotaIbsEstadual: value?.aliquotaIbsEstadual ?? 0.1,
                    aliquotaIbsMunicipal: value?.aliquotaIbsMunicipal ?? 0,
                    reducaoCbs: value?.reducaoCbs ?? 0,
                    reducaoIbsEstadual: value?.reducaoIbsEstadual ?? 0,
                    reducaoIbsMunicipal: value?.reducaoIbsMunicipal ?? 0,
                    valorCbs: value?.valorCbs ?? 0,
                    valorIbsEstadual: value?.valorIbsEstadual ?? 0,
                    valorIbsMunicipal: value?.valorIbsMunicipal ?? 0,
                    totalIbsCbs: value?.totalIbsCbs ?? 0,
                    valorBaseCalculoIbsCbs: value?.valorBaseCalculoIbsCbs ?? 0
                }

                this.calcularIbsCbsServico()
                await this.$nextTick()
                this.syncingFromParent = false
            },
            immediate: true
        },

        objNf: {
            handler(value){
                if (this.syncingFromParent) return
                this.$emit('nf', value)
            },
            deep: true,
            immediate: true
        },

        ['item.jobItensList']: {
            handler(jobItensList){
                let jobItens = jobItensList?.map((item) => {
                    return {
                        ...item,
                        id: item?._id || item.id
                    }
                })

                this.objNf.jobItens = jobItens
            },
            deep: true,
            immediate: true
        },

        ['item.job']: {
            async handler(job){
                if (!job) return
                await this.selectedJob(job)
            },
            deep: true,
            immediate: true
        },

        userInfo: {
            async handler(value){
                if (!value) return

                if(!value?.id){
                    if (typeof value !== 'string' || !value.trim()) return

                    const response = await Vue.prototype.$http.get(`/Entity/Cliente/${value}`)
                    this.objNf.destinatario = response.data.data
                    this.objNf.cpfOrCnpjTomador = response.data.data.cnpj
                    return
                }

                this.objNf.destinatario = value
                this.objNf.cpfOrCnpjTomador = value?.cnpj
                this.getCnpjInfo(value?.cnpj, 'Tomador')
            },
            deep: true,
            immediate: true
        },

        ['objNf.jobItens'](jobItens){
            if(jobItens.length > 0){
                this.objNf.valorNf = 0 
                this.objNf.baseCalculo = 0

                jobItens?.map((item) => {
                    this.objNf.valorNf += item.precoTotal * 100
                    this.objNf.baseCalculo += item.precoTotal * 100
                })

                this.updtaeSum += 1
                this.calcImpostos()
                return
            }

            this.objNf.valorNf = 0 
            this.objNf.baseCalculo = 0
            this.calcularIbsCbsServico()
        },

        ['objNf.baseCalculo']() {
            if (this.isCalculatingImpostos) return
            this.calcImpostos()
        },

        ['objNf.valorNf']() {
            if (this.isCalculatingImpostos) return
            this.calcImpostos()
        },

        ['objNf.tributacaoMunicipal']() {
            this.calcImpostos()
        },

        ['objNf.aliquota']() {
            this.calcImpostos()
        },

        ['objNf.dedutivel']() {
            this.calcImpostos()
        },

        ['objNf.informarIbsCbs']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.aliquotaCbs']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.aliquotaIbsEstadual']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.aliquotaIbsMunicipal']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.reducaoCbs']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.reducaoIbsEstadual']() {
            this.calcularIbsCbsServico()
        },

        ['objNf.reducaoIbsMunicipal']() {
            this.calcularIbsCbsServico()
        },

        async ['objNf.id']() {
            try {
                await this.getEmitente()
            } catch (error) {
                console.error('[NF Serviço] Falha ao atualizar emitente por objNf.id:', error)
            }
        },

        parcelas: {
            handler(value){
                const totalParcelas = this.sumParcelasInCents()

                if ((!this.objNf.jobItens || this.objNf.jobItens.length === 0) && totalParcelas > 0) {
                    this.objNf.valorNf = totalParcelas
                    this.objNf.baseCalculo = totalParcelas
                    this.calcImpostos()
                }

                this.$emit('parcelas', value)
            },
            deep: true
        },

        valorNf(value){
            //this.totalNf = Number(value.replace(/\./g, '').replace(',', '.'))
            //this.calcImpostos()
        }
    },
    async created(){
        console.log('CREATED >>> ', this.objNf)
        try {
            if(!this.objNf.id){
                this.objNf.dataEmit = new Date().toISOString().split("T")[0]
                await this.getEmitente()
            }
        } catch (error) {
            console.error('[NF Serviço] Erro no created:', error)
        }
    },

    async mounted(){
        try {
            const response = await Promise.allSettled([
                this.getDataEntity("RegimeTributario"),
                this.getDataEntity("ServicoLC116"),
                this.getDataEntity("TributacaoMunicipal"),
                this.getDataEntity("CNAE"),
                this.getNotaFiscalItemCST(),
                this.getNotaFiscalItemClassificacao()
            ])

            this.regimeTributarioList = response[0]?.status === 'fulfilled' ? response[0].value : []
            this.enquadramentoList = response[1]?.status === 'fulfilled' ? response[1].value : []
            this.nbsList = response[1]?.status === 'fulfilled' ? response[1].value : []
            this.tributacaoList = response[2]?.status === 'fulfilled' ? response[2].value : []
            this.cnaeList = response[3]?.status === 'fulfilled' ? response[3].value : []

            this.calcImpostos()
            this.calcularIbsCbsServico()
        } catch (error) {
            console.error('[NF Serviço] Erro no mounted:', error)
            this.$notfy?.warning('Alguns dados auxiliares da NF de serviço não foram carregados.')
        }
    }
}
</script>